import { Modal as ModalModule } from 'common';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import logo from '../../assets/images/claimForm/logo_pip.gif';

const { Modal } = ModalModule;

const onClickPrint = () => {
	window.print();
};

// eslint-disable-next-line react/prefer-stateless-function
class InsuranceClaimForm extends Component {
	render() {
		const { data, modalId } = this.props;
		const printButton = {
			text: 'Print This Page',
			onClick: onClickPrint,
		};

		return (
			<Modal
				modalId={modalId}
				header="Insurance Claim Form"
				secondaryButton={printButton}
				size="large"
				fullHeight
			>
				<div className="history-claim-form insurance-claim-form">
					<div className="form-row">
						{/* Use img tag to make sure the image is loaded in all browsers' printing feature */}
						<img width="135" height="72" alt="logo" src={logo} />
						<div className="header">
							<p className="policy-number">Policy #15735</p>
							<div className="title">
								<h2>
									<b>US POSTAL SERVICE (USPS) CLAIM FORM</b>
								</h2>
								<h2>
									<b>For Lost or Damaged Packages - Revised 08/17S</b>
								</h2>
							</div>
						</div>
					</div>

					<div className="instructions">
						<div className="left-instructions">
							<h3>
								<b>INSTRUCTIONS:</b>
							</h3>
							<ol>
								<li>
									Complete and sign this claim form. Your signature is required
									for processing.
								</li>
								<li>
									Attach a copy of your original invoice billing your customer
									for this shipment.
								</li>
								<li>
									Attach a copy of an email or signed letter from the package
									recipient advising you of the loss or damage.
								</li>
								<li>
									Submit this claim form WITH ITEMS 2 &amp; 3 above using the
									information to the right.
								</li>
							</ol>
						</div>
						<table className="right-instructions">
							<tbody>
								<tr>
									<td colSpan="4">
										Send this claim form PLUS items 2 &amp; 3.
									</td>
								</tr>
								<tr>
									<td>
										<b>Email:</b>
									</td>
									<td colSpan="3">claims@pipinsure.com</td>
								</tr>
								<tr>
									<td>
										<b>or Mail:</b>
									</td>
									<td colSpan="3">
										Parcel Insurance Plan <br />
										PO Box 66708
										<br />
										St. Louis MO 63166-6708
									</td>
								</tr>
								<tr>
									<td>
										<b>Fax:</b>
									</td>
									<td colSpan="3">314-692-7598</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div className="section-margin-botton">
						<h3>
							<b>Important Notes:</b>
						</h3>
						<ol>
							<li>
								You must wait 30 days after the shipment date to submit a claim
								for a LOST package. Claims for DAMAGED packages can be submitted
								at any time. All claims must be submitted within 90 days of the
								shipment date.
							</li>
							<li>
								<strong>
									The package recipient should hold damaged items in the event
									they are requested during claims processing. FAILURE TO RETAIN
									DAMAGED PROPERTY COULD AFFECT FINAL SETTLEMENT OF THE CLAIM.
								</strong>
							</li>
							<li>
								<strong>
									Warning: Any fraudulent claims will make the shipper and/or
									package recipient liable for prosecution for mail fraud under
									the Federal Criminal Code.
								</strong>
							</li>
							<li>
								Call PIP directly with questions or if PIP has not responded to
								your claim within 3 weeks of filing at 314-872-9697.
							</li>
						</ol>
					</div>
					<div id="claim-information" className="section-margin-botton">
						<h3>
							<b>CLAIM INFORMATION</b>
						</h3>
						<div className="form-row">
							<p>Package Recipient&rsquo;s Name:</p>
							<p className="blank-field package-recipients-name">
								{data.packageRecipientsName}
							</p>
						</div>
						<div className="form-row">
							<p>Shipment Date:</p>
							<p className="blank-field date-mailed">{data.dateMailed}</p>
							<p>Customer ID:</p>
							<p className="blank-field custom-id">{data.customerId}</p>
						</div>
						<div className="form-row">
							<p>Tracking/Confirmation #:</p>
							<p className="blank-field insurance-id">{data.insuranceId}</p>
						</div>
						<div className="form-row">
							<p className="claim-type">
								Claim Type:{' '}
								<span>[{data.claimType === 'Loss' ? 'X' : '  '}] LOST</span>
								<span>
									[{data.claimType === 'Damage' ? 'X' : '  '}] DAMAGED
								</span>
								<span>
									[{data.claimType === 'Shortage' ? 'X' : '  '}] SHORTAGE
								</span>
							</p>
						</div>
						<div className="form-row">
							<p>Description of Items:</p>
							<p className="blank-field description">{data.description}</p>
						</div>
						<div className="form-row claim-container">
							<table>
								<tbody>
									<tr>
										<td className="claim-value">{data.amountOfClaim}</td>
										<td>
											Amount of claim (invoice or repair cost excluding shipping
											fees)
										</td>
									</tr>
									<tr>
										<td className="claim-value">{data.amountPaidByUSPS}</td>
										<td>Less amount paid by USPS, if any</td>
									</tr>
									<tr>
										<td className="claim-value">{data.lessSalvageValue}</td>
										<td>
											Less salvage value of DAMAGED goods (this does not apply
											if package is LOST)
										</td>
									</tr>
									<tr>
										<td className="claim-value">{data.pip_owes}</td>
										<td>Balance to be paid by PIP</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div id="contact-information" className="section-margin-botton">
						<h3>
							<b>Shipper&rsquo;s Contact Information</b>
						</h3>
						<div className="form-row">
							<p>Shipper&rsquo;s Name:</p>
							<p className="blank-field name">{data.name}</p>
							<p>Send check to attention of:</p>
							<p className="blank-field name">{data.name2}</p>
						</div>
						<div className="form-row">
							<p>Shipper&rsquo;s Mailing Address:</p>
							<p className="blank-field address">{data.address}</p>
						</div>
						<div className="form-row">
							<p>City, State, Zip:</p>
							<p className="blank-field city-state-zip">
								{data.city},{data.state}
								{data.zip}
							</p>
							<p>Telephone:</p>
							<p className="blank-field telephone">{data.telephone}</p>
						</div>
						<div className="form-row">
							<p>Email Address:</p>
							<p className="blank-field email">{data.email}</p>
						</div>
						<p>
							<strong>I certify that the above statements are correct.</strong>
						</p>
						<div className="form-row">
							<p>
								<strong>Signature:</strong>
							</p>
							<p className="blank-field signature" />
						</div>
						<div className="form-row pip-use-only">
							<div className="pip-use-only-content">
								<p className="title">FOR PIP USE ONLY</p>
								<p>AMOUNT: $____________________</p>
								<p>DATE: __________ BY: ___________</p>
							</div>
						</div>
					</div>
				</div>
			</Modal>
		);
	}
}

InsuranceClaimForm.propType = {
	data: PropTypes.object.isRequired,
};

export default InsuranceClaimForm;
